import complyRegulator from './regulator';

export default complyRegulator;
